import React from "react";
import { useSelector } from "react-redux";

const SidePanel = ({
  selectedPanel,
  togglePanel,
  handlePanelClick,
  stepSelected,
  handleStepClick,
  panelId,
  title,
  steps,
  step_details,
}) => {
  const detailsStore = useSelector((state) => state.details);
  return (
    <div className="panel">
      <button
        className={`panel-heading ${
          selectedPanel === panelId ? "" : "collapsed"
        }`}
        id={panelId}
        onClick={(e) => handlePanelClick(e)}
        disabled={detailsStore.formLoading}
      >
        {title}
        <span className="fa fa-chevron-down"></span>
      </button>
      <div
        className={`panel-collapse collapsein ${
          selectedPanel === panelId && togglePanel ? "" : "collapse"
        }`}
        aria-labelledby={panelId}
      >
        <div className="panel-body">
          <ul className="nav nav-tabs wizard_tab_steps child_menu ul_main_cls">
            {Object.entries(steps).map(([key, step]) => {
              return +step.is_visible === 1 ? (
                <React.Fragment key={key}>
                  <li
                    className={`commLiCls ${
                      key === stepSelected ? "active" : ""
                    } ${
                      step_details && +step_details[key].is_completed
                        ? "complete-tab"
                        : ""
                    }`}
                    onClick={() => handleStepClick(key, step)}
                    disabled={detailsStore.formLoading}
                  >
                    <button className="trigger-view-loan-offer">
                      {step.title}
                    </button>
                  </li>
                </React.Fragment>
              ) : null;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default SidePanel;
